/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as ExcelJS from 'exceljs';
import { Dropdown } from 'antd';
import { AutoTooltip } from '../../../components/auto-tooltip';
import { IPageGameManageItem, RbacRoleType } from '../../../model';
import {
  CommonStatusStep,
  IAPICompanyFullInfo,
  IAPIServiceConfigItem,
  IAPIServicesOpenItem,
  IAPIStudioMemberHasPermissionItem,
  IAPIStudioMemberItem,
  IAPIUserInfo,
  IGameListItem,
  IStudioInfo,
  RbacAdminPermObjectKey,
  RoleType,
  StudioCertifiedType,
} from '../../../model/api-modules';
import { IGameEnvModel } from '../../../model/api-modules/env';
import styles from './index.module.scss';
import { MoreOutlined } from '@ant-design/icons';
import { PaginationTable } from '../../../components/pagination-table';

import { getLocalTime, strToJson } from '../../../lib';

import { CommonTag, CommonTagGroup } from '../../../components/tag';
import { IDetailConfig, openDetail } from './detail';
import {
  adminDeleteStudio,
  adminGetStudioMembersHasPermission,
  getSupportCompanyInfo,
} from '../../../api';
import { ModalWrap } from '../../../components/modal-wrap';
import { supportDeleteGame } from '../../../api/admin/game';
import { messageSuccess } from '../../../components/message';
import { IEnvTask } from '../../lib';
import { getUserNameByEmail } from '../lib/columns';
import { CustomPopover } from '../../../components/custom-popover';
import { AdminPermCheck } from '../components/admin-permission-check';
import { CommonButton, DangerButton } from '../../../components/button/main';

export const getJoinEnvGameList = (
  selectedStudios: string[] = [],
  gameList: IGameListItem[] = [],
  studioList: IStudioInfo[] = [],
  envList: IGameEnvModel[] = [],
  envTasks: IEnvTask[] = [],
  serviceOpenList: IAPIServicesOpenItem[] = [],
  serviceConfigs: IAPIServiceConfigItem[] = []
): IPageGameManageItem[] => {
  const filterGames = selectedStudios.length
    ? gameList.filter((game) => selectedStudios.includes(game.StudioID))
    : [];

  return filterGames
    .map((game) => {
      const studioInfo = studioList.find(
        (studio) => studio.StudioID === game.StudioID
      );
      return {
        ...game,

        studioInfo,
        envs: envList
          .filter((env) => env.GameID === game.GameID)
          .map((env) => {
            return {
              ...env,
              studioInfo,
              gameInfo: game,
              task: envTasks.find((task) => task.env_id === env.Guid),
              services: serviceOpenList
                .filter((service) => service.EnvID === env.id)
                .map((service) => {
                  return {
                    ...service,
                    ServiceName: serviceConfigs.find(
                      (item) => item.id === service.ServiceID
                    )?.Name,
                  };
                }),
            };
          }),
      };
    })
    .sort((a, b) => (a.StudioID > b.StudioID ? 1 : -1));
};

export const getGameManageStudioLabel = (
  studio: IStudioInfo,
  gameList: IPageGameManageItem[],
  companyList: IAPICompanyFullInfo[] = [],
  onChange: (studioID: string) => Promise<void>,
  userInfo: IAPIUserInfo | null
) => {
  const isOpenedService = gameList
    .filter((game) => game.StudioID === studio.StudioID)
    .some((game) => game.envs.some((env) => env.services.length > 0));
  const isGameInStudioCertified = isStudioCertified(
    studio.StudioID,
    companyList
  );
  const getTip = () => {
    if (isGameInStudioCertified) {
      return '已企业认证不支持删除';
    }
    if (isOpenedService) {
      return '已开通服务不支持删除';
    }
  };
  return (
    <div className={styles.studioItem}>
      <AutoTooltip fontSize={14} title={`${studio.Name}（${studio.StudioID}）`}>
        <span>
          {studio.Name}（{studio.StudioID}）
        </span>
      </AutoTooltip>
      <span
        onClick={(ev) => {
          ev.stopPropagation();
        }}
      >
        <Dropdown
          getPopupContainer={(node) => node.parentElement as HTMLElement}
          menu={{
            items: [
              {
                key: '1-1',
                label: '详情',
                onClick: async (info) => {
                  info.domEvent.stopPropagation();

                  const [companyInfo, members = []] = await Promise.all([
                    getSupportCompanyInfo(studio.StudioID),
                    adminGetStudioMembersHasPermission(studio.StudioID),
                  ]);
                  const owner = members.find((item) =>
                    item.RbacMember.some(
                      (role) => role.roleType === RoleType.Owner
                    )
                  );
                  const getMemberRoleGroup = (
                    member: IAPIStudioMemberHasPermissionItem
                  ) => {
                    const roleGroups = member.RbacMember;
                    if (
                      roleGroups.some(
                        (item) => item.roleType === RoleType.Owner
                      )
                    ) {
                      return ['Owner'];
                    }
                    if (
                      roleGroups.some(
                        (item) => item.roleType === RoleType.Admin
                      )
                    ) {
                      return ['Admin Group'];
                    }
                    return roleGroups
                      .map((item) => item.groupName)
                      .filter(Boolean);
                  };
                  const basicArea: IDetailConfig = {
                    label: '基础信息',
                    splitColumnNum: 2,
                    items: [
                      {
                        label: '工作室名称',
                        value: studio.Name,
                      },
                      {
                        label: '工作室ID',
                        value: studio.StudioID,
                      },
                      {
                        label: '所有人(账户邮箱)',
                        value: `${getUserNameByEmail(owner?.UserID)}(${
                          owner?.UserID
                        })`,
                      },
                      {
                        label: '创建时间',
                        value: getLocalTime(
                          studio.CreateTime,
                          userInfo?.UserSettings?.Timezone
                        ),
                      },
                    ],
                  };
                  const companyArea: IDetailConfig = {
                    label: '认证信息',
                    splitColumnNum: 2,
                    items: [
                      {
                        label: '企业名称',
                        value: companyInfo?.company?.Name,
                      },
                      {
                        label: '社会信用代码',
                        value: companyInfo?.company?.CreditCode,
                      },
                      {
                        label: '认证地区',
                        value: '中国大陆',
                      },
                      {
                        label: '企业联系人',
                        value: companyInfo?.company?.Contacts?.split('|')[0],
                      },
                      {
                        label: '身份证号',
                        value: companyInfo?.company?.Contacts?.split('|')[1],
                      },
                      {
                        label: '手机号码',
                        value: companyInfo?.company?.Contacts?.split('|')[2],
                      },
                      {
                        label: '企业简介',
                        value: companyInfo?.company?.Description,
                      },
                    ],
                  };
                  const internalCertArea: IDetailConfig = {
                    label: '认证信息',
                    splitColumnNum: 2,
                    items: [
                      {
                        label: '项目名称',
                        value: strToJson<any>(
                          companyInfo?.studioCertRes?.CertInfo
                        )?.projectName,
                      },
                      {
                        label: '项目负责人',
                        value: strToJson<any>(
                          companyInfo?.studioCertRes?.CertInfo
                        )?.projectOwner,
                      },

                      {
                        label: 'Kpi Code',
                        value: strToJson<any>(
                          companyInfo?.studioCertRes?.CertInfo
                        )?.productCode,
                      },
                    ],
                  };
                  const memberArea: IDetailConfig = {
                    label: '成员信息',
                    customRender: () => {
                      const sortMembers = [...members].sort((a, b) => {
                        const isOwner = (
                          member: IAPIStudioMemberHasPermissionItem
                        ) => getMemberRoleGroup(member).includes('Owner');
                        const isAdmin = (
                          member: IAPIStudioMemberHasPermissionItem
                        ) =>
                          getMemberRoleGroup(member).includes('Admin Group') ||
                          isOwner(member);
                        if (isOwner(b) && !isOwner(a)) {
                          return 1;
                        }
                        if (isAdmin(b) && !isAdmin(a)) {
                          return 1;
                        }
                        return -1;
                      });
                      return (
                        <PaginationTable
                          className="game-manage-studio-members"
                          list={sortMembers}
                          pagination={false}
                          configFields={[
                            {
                              key: 'User',
                              name: '成员名称',
                              tableExtension: {
                                renderRow(_key, _val, record) {
                                  return record.UserID.split('@')[0];
                                },
                              },
                            },
                            {
                              key: 'UserID',
                              name: '邮箱',
                            },
                            {
                              key: 'ProjectCode',
                              name: '角色/用户组',
                              tableExtension: {
                                renderRow(_key, _val, record) {
                                  const groups = getMemberRoleGroup(record);

                                  return (
                                    <CommonTagGroup
                                      items={groups.map((name) => {
                                        return {
                                          text: name,
                                          type: 'white',
                                        };
                                      })}
                                    />
                                  );
                                },
                              },
                            },
                          ]}
                          autoMaxHeight={false}
                        />
                      );
                    },
                  };
                  let areas = [basicArea, memberArea];

                  if (
                    companyInfo?.isCertified &&
                    companyInfo.certifiedType ===
                      StudioCertifiedType.InternalKpiCode
                  ) {
                    areas = [basicArea, internalCertArea, memberArea];
                  }

                  if (
                    companyInfo?.isCertified &&
                    companyInfo.certifiedType === StudioCertifiedType.Company
                  ) {
                    areas = [basicArea, companyArea, memberArea];
                  }

                  openDetail('工作室详情', areas);
                },
              },
              {
                key: '1-2',
                label: (
                  <AdminPermCheck
                    contentType="action"
                    permissionKey={RbacAdminPermObjectKey.GameManageEdit}
                    placement="bottom"
                    otherTips={getTip()}
                  >
                    <DangerButton type="link"> 删除 </DangerButton>
                  </AdminPermCheck>
                ),
                danger: true,
                disabled: isOpenedService || isGameInStudioCertified,
                onClick: async (info) => {
                  ModalWrap.show({
                    title: '删除工作室',
                    oKText: '删除',
                    cancelText: '取消',
                    danger: true,
                    onOk: async () => {
                      const games = gameList.filter(
                        (game) => game.StudioID === studio.StudioID
                      );
                      const gameDeleteRes = await Promise.all(
                        games.map((game) =>
                          supportDeleteGame(game.GameID, game.StudioID)
                        )
                      );
                      if (!games.length || gameDeleteRes.every(Boolean)) {
                        const res = await adminDeleteStudio(studio.StudioID);
                        if (res) {
                          onChange(studio.StudioID);
                          messageSuccess('删除成功');
                          return true;
                        }
                      }
                      return false;
                    },
                    children: (
                      <>
                        <div style={{ marginBottom: 10 }}>
                          提示:删除操作无法撤销，请谨慎操作
                        </div>
                        <div>
                          <div> 是否确认删除以下工作室？</div>
                          {studio.Name}({studio.StudioID})
                        </div>
                      </>
                    ),
                  });

                  info.domEvent.stopPropagation();
                },
              },
            ],
          }}
          placement="bottomLeft"
        >
          <MoreOutlined style={{ color: '#4E5969' }} />
        </Dropdown>
      </span>
    </div>
  );
};

export const isStudioCertified = (
  studioId = '',
  companyList: IAPICompanyFullInfo[] = []
) => {
  return (
    companyList
      .filter((company) => company.StudioID === studioId)
      .sort((a, b) => ((a.ModifyTime || 0) < (b.ModifyTime || 0) ? 1 : -1))[0]
      ?.Status === CommonStatusStep.Resolve
  );
};

export const getGameManageStudioList = (
  studioList: IStudioInfo[] = [],
  companyList: IAPICompanyFullInfo[] = [],
  gameList: IPageGameManageItem[] = [],
  onChange: (studioID: string) => Promise<void>,
  userInfo: IAPIUserInfo | null
) => {
  return studioList
    .map((studio) => {
      return {
        value: studio.StudioID,
        text: `${studio.Name}(${studio.StudioID})`,
        label: getGameManageStudioLabel(
          studio,
          gameList,
          companyList,
          onChange,
          userInfo
        ),
      };
    })
    .sort((a, b) => (a.value > b.value ? 1 : -1));
};
